import React, { useState, useEffect, useRef } from "react";
import PropTypes from "prop-types";
import { useSelector } from 'react-redux';
import moment from 'moment';
import { Form, Divider, Table, message, Modal, Row, Col, DatePicker, Spin, Drawer, Space } from 'antd';
import { TimePicker } from "@vaadin/react-components/TimePicker";
import { Zap, CalendarClock } from "lucide-react";
import { Scrollbars } from 'react-custom-scrollbars';
import FeatherIcon from 'feather-icons-react';
import 'react-date-range/dist/styles.css';
import 'react-date-range/dist/theme/default.css';
import { AddUser } from '../style';
import { BasicFormWrapper } from '../../styled';
import { AutoComplete } from '../../../components/autoComplete/autoComplete';
import { Button } from '../../../components/buttons/buttons';
import CampaignTemplate from '../Popup/CampaignTemplate'
import ConfirmationPopup from '../Popup/ConfirmationPopup'
import CustomHtmlParser from '../Email/CustomHtmlParser'
import { CampaignUpdate, getCampaignSendReport } from '../../../Api/Services/CampaignApiServices'
import { SystemLogsIcon, EmailTemplateIcon, ScheduledIcon, ForwardIcon } from "../../../components/Icons/Icons";

const Popup = ({ openUser, exportData, usersTableColumns, OpenUserTable, selectedRowKeys, openType, displayData, getCampaignData }) => {
    const [searchText, setSearchText] = useState("");
    const [filterDatas, setFilterDatas] = useState([]);
    const loadingRef = useRef(false);
    const [deleteClick, setDelteClick] = useState(false)
    const [display, setDisplay] = useState(false)
    const [selectedRowKeysPopup, setSelectedRowKeysPopup] = useState([]);
    // const MAX_SELECTION = 100;
    const onSelectChangePopup = (newSelectedRowKeys) => {
        // if (newSelectedRowKeys.length > MAX_SELECTION) {
        //     message.warning(`You can only perform bulk actions on up to ${MAX_SELECTION} records at a time`);
        //     setSelectedRowKeysPopup(newSelectedRowKeys.slice(0, MAX_SELECTION));
        //     return;
        // }
        setSelectedRowKeysPopup(newSelectedRowKeys);
    };
    const rowSelectionPopup = {
        selectedRowKeysPopup,
        onChange: onSelectChangePopup,
    };
    function updateCampaignIds(campaign, newIds, type) {
        const field = type === 'Lead' ? 'leadSegment' : 'contactSegment';
        const existingIds = campaign[field]
            ? campaign[field].split(',').map(id => parseInt(id.trim())).filter(Boolean)
            : [];
        const updatedIds = Array.from(new Set([...existingIds, ...newIds]));
        const updatedString = updatedIds.join(',');
        return { [field]: updatedString };
    }
    const ConfirmUser = async () => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setDelteClick(true)
        if (selectedRowKeysPopup.length) {
            setDisplay(true)
            let hideMessage;
            const formData = updateCampaignIds(displayData, selectedRowKeysPopup, openType)
            try {
                hideMessage = message.loading("Loading...", 0);
                const response = await CampaignUpdate(formData, displayData?.campaignId)
                if (response.status === 200) {
                    message.success(`Selected segment(s) have been successfully added to the campaign`)
                    hideMessage();
                    setDisplay(false)
                    OpenUserTable()
                    getCampaignData()
                    loadingRef.current = false;
                    setDelteClick(false)
                }
            }
            catch (error) {
                loadingRef.current = false;
                setDelteClick(false)
                hideMessage();
                setDisplay(false)
                message.error(error)
            }
        }
        else {
            loadingRef.current = false;
            setDelteClick(false)
            message.error("Please select atleast one segment")
        }
    }
    const handleSearch = (searchText) => {
        setSearchText(searchText);
    };
    const normalizeValue1 = (value) => {
        if (value == null) return null;
        const trimmed = value?.trim?.();
        if (trimmed === "") return "";
        return trimmed ?? value;
    };
    const filterData = (data) => {
        let filteredData = [...data];
        if (searchText) {
            filteredData = filteredData.filter(item => {
                const searchableFields = [
                    normalizeValue1(item.segmentName),
                    // item.segmentType,
                    normalizeValue1(item.module),
                ];
                return searchableFields.some(field =>
                    field && field.toString().toUpperCase().includes(normalizeValue1(searchText).toUpperCase())
                );
            });
        }
        return filteredData;
    };
    const applyFilters = () => {
        const filteredData = filterData(exportData.filter(item => item.module === openType))
        setFilterDatas(filteredData);
    };
    useEffect(() => {
        applyFilters();
    }, [searchText, exportData, openType]);
    const usersTableDataPopup = [];
    if (filterDatas !== undefined) {
        filterDatas.filter(item => item.module === openType).map((product, key) => {
            return usersTableDataPopup.push({
                Id: key + 1,
                key: product.segmentId,
                name: <div className='table_list_clicks'>{product.segmentName}</div>,
                type: <div className='table_list_clicks'>{product.segmentType}</div>,
                module: <div className='table_list_clicks'>{product.module}</div>,
                numberOf: <div className='table_list_clicks'>{product.module === "Lead" ? product.leads.length : product.contacts.length}</div>,
            });
        });
    }
    const availableRows = usersTableDataPopup.filter(
        item => !selectedRowKeys.includes(Number(item.key))
    );
    return (
        <Modal
            title={
                <Row>
                    <Col xxl={4} lg={4} xs={24}>
                        <div style={{ margin: "7px 0px" }}>
                            Select Segments
                        </div>
                    </Col>
                    <Col xxl={12} lg={12} xs={24}>
                        <AutoComplete
                            onSearch={handleSearch}
                            dataSource={availableRows}
                            placeholder="Search by Name/Module"
                            width="100%"
                            patterns />
                    </Col>
                </Row>
            }
            open={openUser}
            onCancel={OpenUserTable}
            maskClosable={false}
            footer={[
                <div>
                    <Button htmlType="submit" className="button_colors" onClick={() => ConfirmUser()} disabled={display || deleteClick} loading={deleteClick}>
                        {!deleteClick && <FeatherIcon icon="plus" />}Add
                    </Button>
                </div>
            ]}
            width={1000}
        >
            <div className="table-bordered leaderboard-table table-responsive CampaignTable-pagination">
                <Table
                    showSorterTooltip={false}
                    rowSelection={rowSelectionPopup}
                    dataSource={availableRows}
                    columns={usersTableColumns}
                    pagination={{
                        total: availableRows.length,
                        showTotal: (total, range) => `${range[0]}-${range[1]} of ${total} items`,
                    }}
                />
            </div>
        </Modal >
    );
};

Popup.propTypes = {
    openUser: PropTypes.bool.isRequired,
    exportData: PropTypes.array.isRequired,
    usersTableColumns: PropTypes.array.isRequired,
    OpenUserTable: PropTypes.func.isRequired,
    selectedRowKeys: PropTypes.array.isRequired,
    openType: PropTypes.string.isRequired,
    displayData: PropTypes.object.isRequired,
    getCampaignData: PropTypes.func.isRequired,
};

const CamReports = ({ allSegment, emailactiontype1, emailactiontype, displayData, getCampaignData, campaignSendStatus, refreshTrigger, loading1, tabKey, isButtonEnabled, CancelCampaign, loading, RunCampaign, sendGrid }) => {
    const [form] = Form.useForm();
    const toggleBtnBase = {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        gap: 8,
        borderRadius: 12,
        padding: "12px 16px",
        fontSize: 12,
        fontWeight: 600,
        cursor: "pointer",
        border: "1px solid transparent",
    };
    const localData = useSelector((state) => state.localRedux);
    const ProfileData = localData.profile
    const profile = ProfileData
    const loadingRef = useRef(false);
    const [loading2, setLoading2] = useState(false)
    const [display, setDisplay] = useState(false)
    const [openUser, setOpenUser] = useState(false)
    const [openType, setOpenType] = useState()
    const [configType, setConfigType] = useState(false)
    const [openTemplate, setOpenTemplate] = useState(false)
    const [UserexportData, setUserExportData] = useState([])
    const [UserfilterDatas, setUserFilterDatas] = useState([])
    const [UserRemovealKeys, setUserRemovealKeys] = useState([])
    const [UserRemovealKeys1, setUserRemovealKeys1] = useState([])
    const [UserselectedRowKeys, setUserSelectedRowKeys] = useState([])
    const [UserselectedRowKeys1, setUserSelectedRowKeys1] = useState([])
    const [sendMode, setSendMode] = useState("Send Immediately");
    const [confirmPopup, setConfirmPopup] = useState(false)
    const [openFilter2, setOpenFilter2] = useState(false)
    const [reportLoading, setReportLoading] = useState(false)
    const [reportContent, setReportContent] = useState()

    const convertTime = (timeStr, timeFormat) => {
        let hours;
        let minutes;
        // let seconds;
        let period;
        if (timeStr.toLowerCase().includes('am') || timeStr.toLowerCase().includes('pm')) {
            // Parse 12-hour time string
            const timeParts = timeStr.match(/(\d{1,2}):(\d{2}):?(\d{2})?/);
            hours = parseInt(timeParts[1], 10);
            minutes = parseInt(timeParts[2], 10);
            // seconds = parseInt(timeParts[3], 10);
            period = timeStr.match(/(am|pm)/i)[0].toLowerCase();

            if (period === 'pm' && hours !== 12) {
                hours += 12;
            } else if (period === 'am' && hours === 12) {
                hours = 0;
            }
        } else {
            // Parse 24-hour time string
            const timeParts = timeStr.split(':');
            hours = parseInt(timeParts[0], 10);
            minutes = parseInt(timeParts[1], 10);
            // seconds = parseInt(timeParts[2], 10);
        }
        if (timeFormat === '12hrs' || timeFormat === '12-hour') {
            period = hours >= 12 ? 'PM' : 'AM';
            hours = hours % 12 || 12;
            // return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')} ${period}`;
            return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')} ${period}`;
        }
        // No need for an else here because we return in the if above
        if (timeFormat === '24hrs' || timeFormat === '24-hour') {
            // return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}:${String(seconds).padStart(2, '0')}`;
            return `${String(hours).padStart(2, '0')}:${String(minutes).padStart(2, '0')}`;
        }
        throw new Error('Invalid time format specified');
    };
    const getZoneName = (tz) => {
        if (!tz) return null;
        const match = tz.match(/\)\s*(.+)$/);
        return match ? match[1].trim() : tz.trim();
    };
    const ConfirmUser = async (formData, type, newData) => {
        setDisplay(true)
        let hideMessage;
        try {
            hideMessage = message.loading("Loading...", 0);
            const response = await CampaignUpdate(formData, displayData?.campaignId)
            if (response.status === 200) {
                message.success(`Selected Segment have been successfully removed from the campaign`)
                hideMessage();
                setDisplay(false)
                if (type === "leads") {
                    setUserSelectedRowKeys(newData)
                    setUserRemovealKeys([])
                }
                if (type === "contacts") {
                    setUserSelectedRowKeys1(newData)
                    setUserRemovealKeys1([])
                }
                getCampaignData()
            }
        }
        catch (error) {
            hideMessage();
            setDisplay(false)
            message.error(error)
        }
    }
    const openTemplateFunction = (type) => {
        setOpenTemplate(!openTemplate)
        setConfigType(type)
    }
    const OpenUserTable = (type) => {
        setOpenUser(!openUser)
        setOpenType(type)
    }
    // const MAX_SELECTION = 100;
    const onSelectChange = (newSelectedRowKeys) => {
        // if (newSelectedRowKeys.length > MAX_SELECTION) {
        //     message.warning(`You can only perform bulk actions on up to ${MAX_SELECTION} records at a time`);
        //     setUserRemovealKeys(newSelectedRowKeys.slice(0, MAX_SELECTION));
        //     return;
        // }
        setUserRemovealKeys(newSelectedRowKeys)
    };
    const onSelectChange1 = (newSelectedRowKeys) => {
        // if (newSelectedRowKeys.length > MAX_SELECTION) {
        //     message.warning(`You can only perform bulk actions on up to ${MAX_SELECTION} records at a time`);
        //     setUserRemovealKeys1(newSelectedRowKeys.slice(0, MAX_SELECTION));
        //     return;
        // }
        setUserRemovealKeys1(newSelectedRowKeys)
    };
    const UserDataRemoved = (type) => {
        const newData = UserselectedRowKeys.filter(item => !UserRemovealKeys.includes(item));
        const payload = { leadSegment: (newData && newData.length > 0) ? newData.join(',') : null, }
        ConfirmUser(payload, type, newData)
    }
    const UserDataRemoved1 = (type) => {
        const newData = UserselectedRowKeys1.filter(item => !UserRemovealKeys1.includes(item));
        const payload = { contactSegment: (newData && newData.length > 0) ? newData.join(',') : null, }
        ConfirmUser(payload, type, newData)
    }
    const rowSelection = {
        selectedRowKeys: UserRemovealKeys,
        onChange: onSelectChange,
        getCheckboxProps: () => ({
            disabled: UserRemovealKeys1.length > 0,
        }),
    };
    const rowSelection1 = {
        selectedRowKeys: UserRemovealKeys1,
        onChange: onSelectChange1,
        getCheckboxProps: () => ({
            disabled: UserRemovealKeys.length > 0,
        }),
    };
    const usersTableColumns = [
        {
            title: 'Segment Name',
            dataIndex: 'name',
            key: 'name',
            width: "40%",
            ellipsis: true,
        },
        {
            title: 'Segment Type',
            dataIndex: 'type',
            key: 'type',
            width: "30%",
            ellipsis: true,
        },
        {
            title: 'No of Records',
            dataIndex: 'numberOf',
            key: 'numberOf',
            width: "30%",
            ellipsis: true,
        },
    ];
    const usersTableData = [];
    if (UserfilterDatas) {
        UserfilterDatas.map((product, key) => {
            return usersTableData.push({
                Id: key + 1,
                key: product.segmentId,
                name: <div className='table_list_clicks'>{product.segmentName}</div>,
                type: <div className='table_list_clicks'>{product.segmentType}</div>,
                module: <div className='table_list_clicks'>{product.module}</div>,
                numberOf: <div className='table_list_clicks'>{product.module === "Lead" ? product.leads.length : product.contacts.length}</div>,
            });
        });
    }
    useEffect(() => {
        if (refreshTrigger === tabKey) {
            if (displayData && allSegment) {
                if (allSegment) {
                    setUserSelectedRowKeys([])
                    setUserRemovealKeys([])
                    setUserSelectedRowKeys(displayData.leadSegment ? displayData.leadSegment.split(",").map(user => Number(user)) : [])
                }
                if (allSegment) {
                    setUserSelectedRowKeys1([])
                    setUserRemovealKeys1([])
                    setUserSelectedRowKeys1(displayData.contactSegment ? displayData.contactSegment.split(",").map(user => Number(user)) : [])
                }
                setUserExportData(allSegment)
                setUserFilterDatas(allSegment)
            }
            setSendMode(displayData?.mailTriggerType || "Send Immediately")
            form.setFieldsValue({
                time: displayData?.triggerTime,
                date: displayData?.triggerDate
                    ? moment(displayData.triggerDate, "YYYY-MM-DD")
                    : null,
            })
        }
    }, [displayData, allSegment, refreshTrigger, tabKey])
    const isMailSent = campaignSendStatus?.campaignMailStatus || null
    const onSubmit = (values) => {
        if (loadingRef.current) return;
        loadingRef.current = true;
        setLoading2(true)
        const today = moment().startOf("day");
        const startDate = moment(displayData?.startDate, "YYYY-MM-DD");
        const endDate = moment(displayData?.endDate, "YYYY-MM-DD");

        const dateFormat = profile?.dateFormate || "YYYY-MM-DD";
        if (!today.isBetween(startDate, endDate, "day", "[]")) {
            message.error(
                `The campaign can only be triggered between ${moment(displayData?.startDate).format(dateFormat)} and ${moment(displayData?.endDate).format(dateFormat)}`
            );
            loadingRef.current = false;
            setLoading2(false)
            return;
        }
        const payload = {
            mailTriggerType: sendMode,
            triggerDate: values?.date?.format("YYYY-MM-DD") || null,
            triggerTime: values?.time || null,
        };
        RunCampaign(payload)
        loadingRef.current = false;
        setLoading2(false)
    };
    const onFinishFailed = () => {
        message.error("Please fill out all required fields")
    }
    const disabledDate = current => {
        return current && current < moment().startOf('day');
    };
    const canResume = campaignSendStatus?.canResume;
    const shouldShowCancelOption = (sendMode, isMailSent, triggerDate, triggerTime, timeZone) => {
        if (sendMode !== "Send Later") return false;
        if (isMailSent) return false;
        if (!triggerDate || !triggerTime || !timeZone) return false;
        const zoneName = getZoneName(timeZone);
        if (!zoneName) return false;
        const scheduledDateTime = moment.tz(`${triggerDate} ${triggerTime}`, 'YYYY-MM-DD HH:mm', zoneName);
        if (!scheduledDateTime.isValid()) return false;
        const currentTimeInZone = moment.tz(zoneName);
        return currentTimeInZone.isBefore(scheduledDateTime);
    };
    const [showCancelOption, setShowCancelOption] = useState(false);
    useEffect(() => {
        const checkCancelStatus = () => {
            const result = shouldShowCancelOption(
                displayData?.mailTriggerType,
                campaignSendStatus?.campaignMailStatus,
                displayData?.triggerDate,
                displayData?.triggerTime,
                profile?.timeZone,
            );
            setShowCancelOption(result);
        };
        checkCancelStatus();
        const intervalId = setInterval(checkCancelStatus, 2000);
        return () => clearInterval(intervalId);
    }, [displayData?.mailTriggerType, campaignSendStatus?.campaignMailStatus, displayData?.triggerTime, displayData?.triggerDate]);
    const OnClickofDelete = () => {
        setConfirmPopup(true)
    }
    const OnCancel = () => {
        setConfirmPopup(false)
        CancelCampaign()
    }
    async function getApiCallReport(campaignId) {
        try {
            setReportLoading(true)
            const response = await getCampaignSendReport(campaignId);
            setReportContent(response)
            setReportLoading(false)
        } catch (error) {
            setReportLoading(false)
            setOpenFilter2(false)
            message.error(error)
        }
    }
    const FilterOpen2 = (action) => {
        if (action === "Close") {
            setReportContent()
            setReportLoading(false)
        }
        else {
            getApiCallReport(displayData?.campaignId)
        }
        setOpenFilter2((prev) => !prev);
    };
    return (
        <>
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div style={{ fontWeight: "600", fontSize: 16 }}>Selected Lead Segments</div>
                <div style={{ display: "flex", gap: 5 }}>
                    <Button size="small" className="button_outlined" onClick={() => openTemplateFunction('Leads')} disabled={display || UserRemovealKeys.length > 0 || UserRemovealKeys1.length > 0 || isMailSent}>
                        <EmailTemplateIcon /> {displayData?.leadTemplate ? "Edit Template" : "Add Template"}
                    </Button>
                    {UserRemovealKeys.length > 0 ?
                        <Button size="small" className="gray-button" onClick={() => UserDataRemoved('leads')} disabled={display || isMailSent}>
                            <FeatherIcon icon="trash" /> Remove Segments
                        </Button> :
                        <Button size="small" className="button_colors" onClick={() => OpenUserTable("Lead")} disabled={display || UserRemovealKeys1.length > 0 || isMailSent}>
                            <FeatherIcon icon="plus-circle" /> Segments
                        </Button>}
                </div>
            </div>
            <div style={{ margin: "10px 0px 20px" }}>
                <div className="table-bordered leaderboard-table table-responsive CampaignTable-pagination">
                    <Table
                        tableLayout="fixed"
                        showSorterTooltip={false}
                        rowSelection={isMailSent ? undefined : rowSelection}
                        dataSource={usersTableData.filter(item => UserselectedRowKeys.includes(item.key))}
                        columns={usersTableColumns}
                        pagination={false}
                        scroll={{ y: 270 }}
                    />
                </div>
            </div>
            <Divider />
            <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center" }}>
                <div style={{ fontWeight: "600", fontSize: 16 }}>Selected Contact Segments</div>
                <div style={{ display: "flex", gap: 5 }}>
                    <Button size="small" className="button_outlined" onClick={() => openTemplateFunction('Contacts')} disabled={display || UserRemovealKeys.length > 0 || UserRemovealKeys1.length > 0 || isMailSent}>
                        <EmailTemplateIcon /> {displayData?.contactTemplate ? "Edit Template" : "Add Template"}
                    </Button>
                    {UserRemovealKeys1.length > 0 ?
                        <Button size="small" className="gray-button" onClick={() => UserDataRemoved1('contacts')} disabled={display || isMailSent}>
                            <FeatherIcon icon="trash" /> Remove Segments
                        </Button> :
                        <Button size="small" className="button_colors" onClick={() => OpenUserTable("Contact")} disabled={display || UserRemovealKeys.length > 0 || isMailSent}>
                            <FeatherIcon icon="plus-circle" /> Segments
                        </Button>}
                </div>
            </div>
            <div style={{ margin: "10px 0px 20px" }}>
                <div className="table-bordered leaderboard-table table-responsive CampaignTable-pagination">
                    <Table
                        tableLayout="fixed"
                        showSorterTooltip={false}
                        rowSelection={isMailSent ? undefined : rowSelection1}
                        dataSource={usersTableData.filter(item => UserselectedRowKeys1.includes(item.key))}
                        columns={usersTableColumns}
                        pagination={false}
                        scroll={{ y: 270 }}
                    />
                </div>
            </div>
            <Divider />
            < AddUser >
                <Form style={{ width: '100%' }} form={form} name="info" colon={false} onFinishFailed={onFinishFailed}
                    onFinish={onSubmit} >
                    <BasicFormWrapper>
                        <div className="add-product-block">
                            <div className='RightSide-DataShadow' style={{ flex: 1, minWidth: 0, background: "#fff", borderRadius: 16, border: "1px solid #ececec", padding: 20 }}>
                                <div>
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 4 }}>
                                        <div style={{ fontSize: 14, fontWeight: 600, color: "#1f2430" }}>Send Configuration {displayData?.mailProvider ? `(via ${displayData?.mailProvider})` : sendGrid?.isActive ? "(via SendGrid)" : emailactiontype1 ? "(No congiguration)" : `(via ${emailactiontype?.emailType})`}</div>
                                        {!isMailSent && displayData?.mailTriggerType === "Send Later" ?
                                            <div style={{ fontSize: 10, fontWeight: 600, color: "#20c997", display: "flex", alignItems: "center", justifyContent: "center" }}> <ScheduledIcon marginRight={5} width="18" height="18" />{convertTime(displayData.triggerTime, profile.timeFormat || "24hrs")}, {moment(displayData.triggerDate, "YYYY-MM-DD").format("Do MMMM")}</div> : ""}
                                    </div>
                                    <p style={{ fontSize: 13, color: "#a3a3a3", marginBottom: 16 }}>
                                        Choose when this campaign goes out to every segment above
                                    </p>
                                    {/* 
                                    <p style={{ fontSize: 11, fontWeight: 600, letterSpacing: 0.4, textTransform: "uppercase", marginBottom: 8 }}>
                                        When should this send?
                                    </p> */}
                                    <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 12, marginBottom: 16 }}>
                                        <button
                                            type="button"
                                            disabled={isMailSent}
                                            onClick={() => setSendMode("Send Immediately")}
                                            style={{
                                                ...toggleBtnBase,
                                                background: sendMode === "Send Immediately" ? "#fff" : "#f7f7f6",
                                                border: sendMode === "Send Immediately" ? "1px solid #407fe9" : "1px solid transparent",
                                                color: sendMode === "Send Immediately" ? "#407fe9" : "#a3a3a3",
                                                cursor: isMailSent ? "not-allowed" : "pointer",
                                            }}
                                        >
                                            <Zap size={15} />
                                            Trigger immediately
                                        </button>
                                        <button
                                            type="button" disabled={isMailSent}
                                            onClick={() => setSendMode("Send Later")}
                                            style={{
                                                ...toggleBtnBase,
                                                background: sendMode === "Send Later" ? "#407fe9" : "#f7f7f6",
                                                color: sendMode === "Send Later" ? "#fff" : "#a3a3a3",
                                                cursor: isMailSent ? "not-allowed" : "pointer",
                                            }}
                                        >
                                            <CalendarClock size={15} />
                                            Schedule for later
                                        </button>
                                    </div>
                                    {sendMode === "Send Later" && (<>
                                        <div style={{ display: "grid", gridTemplateColumns: "1fr 1fr", gap: 16 }}>
                                            <div>
                                                <Form.Item label="Date" name="date"
                                                    id="date" rules={isMailSent ? [{ required: false, }] : [{ required: true, message: 'Please select date' }]}>
                                                    <DatePicker disabledDate={disabledDate}
                                                        format={profile.dateFormate ? profile.dateFormate : "YYYY-MM-DD"}
                                                        disabled={sendMode !== "Send Later" || isMailSent} allowClear={false}
                                                    />
                                                </Form.Item>
                                            </div>
                                            <div>
                                                <Form.Item label={<>Time <span style={{ fontSize: 10, marginLeft: 5 }}>{profile?.timeZone}</span></>} name="time"
                                                    rules={isMailSent ? [{ required: false }] : [{ required: true, message: 'Please select time' }]}>
                                                    <TimePicker className="custom-timepicker" disabled={sendMode !== "Send Later" || isMailSent}
                                                        step={1800} placeholder="Start Time" />
                                                </Form.Item>
                                            </div>
                                        </div></>
                                    )}
                                </div>
                                <div style={{ background: "#f7f7f6", borderRadius: 16, border: "1px solid #ececec", padding: 20, marginTop: 20 }}>
                                    <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", marginBottom: 12 }}>
                                        <p style={{ fontSize: 11, fontWeight: 600, letterSpacing: 0.4, color: "#a3a3a3", textTransform: "uppercase", marginBottom: 0 }}>
                                            Summary
                                        </p>
                                        {isMailSent &&
                                            <div
                                                className='Hover-Refresh2 back-hover1 able-style'
                                                role="button"
                                                tabIndex={0} title='Campaign Send Log'
                                                onClick={() => FilterOpen2("Open")}
                                                onKeyDown={(event) => {
                                                    if (event.key === 'Enter' || event.key === ' ') {
                                                        FilterOpen2("Open")
                                                    }
                                                }}
                                                aria-label='Campaign Send Log'
                                            ><SystemLogsIcon height={20} width={20} />
                                            </div>}
                                    </div>
                                    <dl style={{ display: "flex", flexDirection: "column", gap: 10, marginBottom: 20 }}>
                                        {isMailSent ? <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontSize: 13 }}>
                                            <dt style={{ color: "#8a8a8a", margin: 0 }}>Status</dt>
                                            <dd style={{ fontWeight: 600, color: "#1f2430", margin: 0 }}>
                                                {isMailSent
                                                    ? campaignSendStatus.campaignMailStatus.charAt(0).toUpperCase() +
                                                    campaignSendStatus.campaignMailStatus.slice(1)
                                                    : ""}
                                            </dd>
                                        </div> : ""}
                                        {/* <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontSize: 13 }}>
                                            <dt style={{ color: "#8a8a8a", margin: 0 }}>Recipients</dt>
                                            <dd style={{ fontWeight: 600, color: "#1f2430", margin: 0 }}>{(displayData?.triggeredRecipients || "0").toLocaleString()}</dd>
                                        </div> */}
                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontSize: 13 }}>
                                            <dt style={{ color: "#8a8a8a", margin: 0 }}>Sending Progress</dt>
                                            <dd style={{ fontWeight: 600, color: "#1f2430", margin: 0 }}> {`${(campaignSendStatus?.pending || 0) +
                                                (campaignSendStatus?.sending || 0) +
                                                (campaignSendStatus?.sent || 0)}/${campaignSendStatus?.total || 0}`}</dd>
                                        </div>
                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontSize: 13 }}>
                                            <dt style={{ color: "#8a8a8a", margin: 0 }}>Failed with Errors</dt>
                                            <dd style={{ fontWeight: 600, color: "#1f2430", margin: 0 }}>
                                                {`${campaignSendStatus?.error || 0}/${campaignSendStatus?.total || 0}`}
                                            </dd>
                                        </div>
                                        {/* <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontSize: 13 }}>
                                            <dt style={{ color: "#8a8a8a", margin: 0 }}>Lead segments</dt>
                                            <dd style={{ fontWeight: 600, color: "#1f2430", margin: 0 }}>{displayData?.leadSuccessCount || "0"}</dd>
                                        </div>
                                        <div style={{ display: "flex", alignItems: "center", justifyContent: "space-between", fontSize: 13 }}>
                                            <dt style={{ color: "#8a8a8a", margin: 0 }}>Contact segments</dt>
                                            <dd style={{ fontWeight: 600, color: "#1f2430", margin: 0 }}>{displayData?.contactSuccessCount || "0"}</dd>
                                        </div> */}
                                    </dl>
                                    {campaignSendStatus?.campaignMailStatus === "completed" ? <></> :
                                        (<div style={{ display: "grid", gridTemplateColumns: "1fr", gap: 12 }}>
                                            {showCancelOption ? (
                                                <button
                                                    onClick={OnClickofDelete}
                                                    type="button"
                                                    disabled={loading || loading1}
                                                    style={{
                                                        width: "100%",
                                                        flex: 1,
                                                        background: "#fff",
                                                        border: "1px solid #e04f4f",
                                                        color: "#e04f4f",
                                                        fontSize: 14,
                                                        fontWeight: 600,
                                                        borderRadius: 12,
                                                        padding: "12px 0",
                                                        cursor: (loading || loading1) ? "not-allowed" : "pointer",
                                                        opacity: (loading || loading1) ? 0.6 : 1,
                                                    }}
                                                >
                                                    {loading1 ? "Cancelling..." : "Cancel Schedule"}
                                                </button>
                                            ) :
                                                <button onClick={() => form.submit()}
                                                    type="button"
                                                    disabled={!isButtonEnabled || loading || loading2 || loading1 || (isMailSent && !canResume)}
                                                    style={{
                                                        width: "100%",
                                                        background: "#407fe9",
                                                        border: "none",
                                                        color: "#fff",
                                                        fontSize: 14,
                                                        fontWeight: 600,
                                                        borderRadius: 12,
                                                        padding: "12px 0",
                                                        cursor: (!isButtonEnabled || loading || loading2 || loading1 || (isMailSent && !canResume))
                                                            ? "not-allowed"
                                                            : "pointer",
                                                        opacity: (!isButtonEnabled || loading || loading2 || loading1 || (isMailSent && !canResume))
                                                            ? 0.6
                                                            : 1,
                                                    }}
                                                >
                                                    {(loading || loading2)
                                                        ? "Scheduling..."
                                                        : canResume
                                                            ? "Resume Campaign"
                                                            : isMailSent
                                                                ? "Launch Campaign"
                                                                : (sendMode === "Send Later" ? "Schedule Campaign" : "Launch Campaign")}
                                                </button>}
                                        </div>)}
                                </div>
                            </div>
                        </div>
                    </BasicFormWrapper>
                </Form >
            </AddUser >
            {openUser && <Popup openUser={openUser} exportData={UserexportData} usersTableColumns={usersTableColumns}
                OpenUserTable={OpenUserTable}
                selectedRowKeys={openType === "Lead" ? UserselectedRowKeys : UserselectedRowKeys1}
                openType={openType} displayData={displayData} getCampaignData={getCampaignData} />
            }
            {openTemplate && <CampaignTemplate openTemplate={openTemplate} setOpenTemplate={openTemplateFunction} configType={configType} displayData={displayData} getCampaignData={getCampaignData} />}
            {confirmPopup && <ConfirmationPopup confirmPopup={confirmPopup} setConfirmPopup={setConfirmPopup} GetCallback={OnCancel} deleteId={1} page="Cancel" />}
            <Drawer className='Drawer-Header'
                bodyStyle={{ padding: 0 }}
                title={
                    <div style={{ display: "flex", alignItems: "center", gap: "50px" }}>
                        <div>
                            Campaign Send Log
                        </div>
                    </div>
                }
                closable={false}
                placement="right"
                open={openFilter2}
                width="90%"
                extra={
                    < Space >
                        <div className='Hover-Refresh2 back-hover1 able-style'
                            role="button"
                            tabIndex={0} title='Close Send Log'
                            onClick={() => FilterOpen2("Close")}
                            onKeyDown={(event) => {
                                if (event.key === 'Enter' || event.key === ' ') {
                                    FilterOpen2("Close")
                                }
                            }}
                            aria-label='Close Send Log'
                        > <ForwardIcon width={24} height={24} /></div>
                    </Space >
                }
            >
                <Scrollbars autoHide autoHideTimeout={500} autoHideDuration={200}>
                    {reportLoading ? <div className="spin"><Spin /></div> :
                        <div style={{ margin: 40 }}>
                            {/* <div>
                            {reportContent}
                        </div> */}
                            <CustomHtmlParser html={reportContent} key={1} />
                        </div>}
                </Scrollbars >
            </Drawer >
        </>
    )
}

CamReports.propTypes = {
    allSegment: PropTypes.array.isRequired,
    displayData: PropTypes.object.isRequired,
    getCampaignData: PropTypes.func.isRequired,
    refreshTrigger: PropTypes.string.isRequired,
    tabKey: PropTypes.string.isRequired,
    loading: PropTypes.bool.isRequired,
    isButtonEnabled: PropTypes.bool.isRequired,
    RunCampaign: PropTypes.func.isRequired,
    CancelCampaign: PropTypes.func.isRequired,
    campaignSendStatus: PropTypes.object.isRequired,
    loading1: PropTypes.bool.isRequired,
    sendGrid: PropTypes.object.isRequired,
    emailactiontype1: PropTypes.any.isRequired,
    emailactiontype: PropTypes.object.isRequired,
};

export default React.memo(CamReports)